<template>
  <div>
    <modal v-if="showModal" @close="close">
      <template slot="body">
        <div class="add-lesson__header" :style="{'backgroundColor': color ? color : '#fff'}">
          <h2>{{ name.length > 0 ? name : !isActivities ? i18n[locale]['create_subject'] : 'Opret aktivitet' }}</h2>
          <div class="add-lesson__calendars">
            {{ showMasterCalendarName }}
          </div>
          <div class="add-lesson__header__tabs" v-if="editSubject && !isActivities">
            <div class="add-lesson__header__tabs__tab" :class="{'tab--is-active': activeTab === 'edit'}"
                 @click="activeTab = 'edit'">
              {{ i18n[locale].edit_subject }}
            </div>
            <div class="add-lesson__header__tabs__tab" :class="{'tab--is-active': activeTab === 'history'}"
                 @click="activeTab = 'history'">
              {{ i18n[locale].activity }}
            </div>
            <div class="add-lesson__header__tabs__tab"
                 v-if="isReductionsActive && isShowReductions"
                 :class="{'tab--is-active': activeTab === 'reductions'}"
                 @click="activeTab = 'reductions'">
              Reduktioner
            </div>
          </div>
        </div>
        <div class="add-lesson__form">
          <div class="add-lesson__form__content" v-if="activeTab === 'history'">
            <h2>{{ i18n[locale].latest_activity }}</h2>
            <SubjectFormLog :subject="editSubject"></SubjectFormLog>
          </div>
          <div class="add-lesson__form__content" v-if="activeTab === 'reductions'">
            <h2>Reduktioner</h2>
            <SubjectFormReductions :subject="editSubject"></SubjectFormReductions>
          </div>
          <div class="add-lesson__form__content" v-if="activeTab === 'edit'">
            <template v-if="editSubject">
              <div class="subjects-requested-by do-warning" v-if="isShowSubjectsRequest && subjectRequestedBy">
                <label class="do-label">{{ i18n[locale]['requested_by'] }}</label> {{ subjectRequestedBy }}
              </div>
              <div class="input-group" v-if="editSubject">
                <label>{{ i18n[locale]['hours_in_school_year'] }}</label>
                <input type="number" ref="inputLessonCount" v-model.number="hours"
                       @focus="selectAllOnFocus($event)"
                       class="do-input"
                       :class="{'input--error': formErrors['hours']}">
                <p class="input-error" v-if="formErrors['hours']">{{ formErrors['hours'][locale] }}</p>
              </div>
              <div class="input-group" v-if="calendarType !== 'user'">
                <label><span class="icon-user"></span> {{ i18n[locale]['add_teacher'] }}</label>
                <DSelectCalendarIds itemType="USER"
                                    :showTags="true"
                                    :preSelectedItems="userCalendarIds"
                                    @update="setSelectedUsers">
                </DSelectCalendarIds>
              </div>
              <div class="input-group">
                <label><span class="icon-location"></span> {{ i18n[locale]['add_room'] }}</label>
                <DSelectCalendarIds itemType="ROOM"
                                    :preSelectedItems="roomCalendarIds"
                                    @update="setSelectedRooms">
                </DSelectCalendarIds>
              </div>
              <p class="text-link" @click="isPossibleToAddKlasses = true"
                 v-if="!isPossibleToAddKlasses && isAllowedToAddKlasses">{{ i18n[locale]['add_klass'] }}?</p>
              <transition name="dropdown">
                <div class="input-group" v-if="isPossibleToAddKlasses">
                  <label><span class="icon-calendar4"></span> {{ i18n[locale]['add_klass'] }}</label>
                  <DSelectCalendarIds itemType="klass"
                                      :calendarId="calendarId"
                                      :showTags="true"
                                      :preSelectedItems="klassCalendarIds"
                                      :showCreateButton="false"
                                      @update="setSelectedKlass">
                  </DSelectCalendarIds>
                </div>
              </transition>
              <div class="input-group">
                <p class="text-blue advanced-settings__link" @click="isEditSubjectAdvanced = !isEditSubjectAdvanced">
                  {{ i18n[locale]['more_settings'] }}
                </p>
              </div>
            </template>
            <template v-if="!editSubject || isEditSubjectAdvanced">
              <div :class="{'input-group__flex': isSubjectCodeActive}">
                <div class="input-group">
                  <label>{{ i18n[locale]['subject_title'] }}</label>
                  <input type="text" v-model="name" :placeholder="isActivities ? 'Eks. Motionsdag' : i18n[locale]['ex_subject']"
                         @keyup="removeErrors('name')"
                         ref="name"
                         class="do-input"
                         :class="{'input--error': formErrors['name']}">
                  <p class="input-error" v-if="formErrors['name']">{{ formErrors['name'][locale] }}</p>
                </div>
                <div class="input-group" style="max-width: 100px" v-if="isArbeidstidsplanActivated">
                  <label>Årsramme</label>
                  <select v-model.number="preparation" class="d-input__select">
                    <option v-for="prep in preparationOptionsForNorway" :key="prep">
                      {{ prep }}
                    </option>
                  </select>
                </div>
                <div class="input-group" style="max-width: 100px" v-if="isSubjectCodeActive">
                  <label>Fagkode</label>
                  <input type="text"
                         class="do-input"
                         v-model.number="subjectCode"
                         @focus="selectAllOnFocus($event)">
                </div>
              </div>
              <div class="input-group input-group__flex" v-if="!editSubject && !isEditSubjectAdvanced">
                <div class="flex-">
                  <label>{{ i18n[locale]['hours_in_school_year'] }}</label>
                  <input type="number" ref="inputLessonCount" v-model.number="hours"
                         class="do-input"
                         @focus="selectAllOnFocus($event)"
                         @blur="removeErrors('hours')"
                         :class="{'input--error': formErrors['hours']}">
                  <p class="input-error" v-if="formErrors['hours']">{{ formErrors['hours'][locale] }}</p>
                </div>
                <div class="flex-1">
                  <label>{{ i18n[locale]['standard_duration'] }}</label>
                  <div class="input-group--flex">
                    <div class="flex-1">
                      <input type="number"
                             class="do-input"
                             v-model="defaultDuration"
                             ref="input_default_duration"
                             @focus="selectAllOnFocus($event)">
                      <p class="input-error"
                         v-if="formErrors['defaultDuration']">{{ formErrors['defaultDuration'][locale] }}</p>
                    </div>
                    <div class="input-group--flex__setting-icon"
                         v-if="userCanManageSchool"
                         :content="$t('vue2.set_standard_duration.set_standard_duration_for_the_school')"
                         v-tippy="{
            arrow: true
          }">
                      <div class="icon__bg-circle" @click="isOpenDurationModal = true"><span class="icon-wrench"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-group" v-if="!calendarId">
                <label>{{ i18n[locale]['choose_class'] }}</label>
                <DSelectKlass @add="addKlass" @remove="removeKlass"></DSelectKlass>
                <p class="input-error" v-if="formErrors['calendarId']">{{ formErrors['calendarId'][locale] }}</p>
              </div>
              <div class="input-group">
                <label>{{ i18n[locale]['choose_color'] }}</label>
                <ColorPicker @changedColor="setSubjectColor"
                             :initialColor="color">
                </ColorPicker>
              </div>
              <div class="input-group" v-if="!isActivities">
                <label>{{ i18n[locale]['choose_subject_type'] }}</label>
                <SubjectTypePicker
                  :calendarType="calendarType"
                  :subjectType="subjectType"
                  @change="selectSubjectType">
                </SubjectTypePicker>
              </div>
            </template>
            <div class="edit-subject" v-if="editSubject">
              <div class="input-group input-group__submit">
                <div class="input-group__submit__left">
                  <button v-if="editSubjectCanBeDeleted"
                          class="hint--right bttn--warning"
                          :aria-label="i18n[locale]['delete_subject']"
                          @click="deleteEditSubject">
                    <span class="icon-bin"></span>
                  </button>
                  <div class="hint--right" v-else :aria-label="i18n[locale]['cannot_delete']">
                    <button class="bttn bttn--disabled">
                      <span class="icon-bin"></span>
                    </button>
                  </div>
                </div>
                <div class="input-group__submit__right">
                  <button class="do-bttn" @click="close">{{ i18n[locale]['cancel'] }}</button>
                  <button class="do-bttn do-bttn--submit" v-if="editSubject"
                          @click="updateSubject">{{ i18n[locale]['update_subject'] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="input-group input-group__submit" v-else>
              <div class="input-group__submit__left">
              </div>
              <div class="input-group__submit__right">
                <button class="do-bttn" @click="close">{{ i18n[locale]['cancel'] }}</button>
                <button class="do-bttn do-bttn--submit" @click="createSubject">
                  {{ !isActivities ? i18n[locale]['create_subject'] : 'Opret aktivitet' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
    <StandardDurationSetting
      :isOpenModal="isOpenDurationModal"
      @close="isOpenDurationModal = false"
      @submit="saveUpdatedDuration">
    </StandardDurationSetting>
    <SubjectFormDeleteSubjects
      v-if="subjectsWithSameName.length > 0"
      :subjectsWithSameName="subjectsWithSameName"
      @close="closeModalSubjectsWithSameName"
      @keep="keepExistingSubjects"
      @delete="deleteExistingSubjects">
    </SubjectFormDeleteSubjects>
  </div>
</template>

<script>
import modal from './Modal'
import DSelectUser from '../DSelect/DSelectUsers'
import DSelectKlass from '../DSelect/DSelectKlass'
import ColorPicker from './ColorPicker'
import SubjectTypePicker from './SubjectFormSubjectType'
import DSelectCalendarIds from '../DSelect/DSelectCalsIds'
import SubjectFormLog from './SubjectFormLog'
import StandardDurationSetting from '../School/StandardDurationSetting'
import SubjectFormDeleteSubjects from './SubjectFormDeleteSubjects'
import SubjectFormReductions from './SubjectFormReductions.vue'

const I18N = {
  da: {
    create_subject: 'Opret fag',
    hours_in_school_year: 'Klokketimer i skoleåret',
    add_teacher: 'Tilføj underviser',
    add_room: 'Tilføj lokale',
    add_klass: 'Tilføj klasse',
    more_settings: 'Yderligere indstillinger',
    subject_title: 'Fagets navn',
    standard_duration: 'Normal varighed (i minutter)',
    choose_class: 'Vælg klasse',
    choose_color: 'Vælg farve',
    choose_subject_type: 'Vælg briktype',
    ex_subject: 'Eks. Dansk',
    cancel: 'Annullér',
    update_subject: 'Opdatér',
    delete_subject: 'Slet faget i klassen',
    edit_subject: 'Redigér',
    activity: 'Historik',
    latest_activity: 'Seneste aktivitet',
    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
    requested_by: 'Ønsket af'
  },
  en: {
    create_subject: 'Create subject',
    hours_in_school_year: 'Hours in school year',
    add_teacher: 'Add teacher',
    add_klass: 'Add grade/group',
    add_room: 'Add room',
    more_settings: 'Advanced settings',
    subject_title: 'Subject title',
    standard_duration: 'Standard duration (in minutes)',
    choose_class: 'Choose class',
    choose_color: 'Choose color',
    choose_subject_type: 'Choose subject category',
    ex_subject: 'E.g. Math',
    cancel: 'Cancel',
    update_subject: 'Update subject',
    delete_subject: 'Delete subject in class',
    edit_subject: 'Edit subject',
    activity: 'History',
    latest_activity: 'Activity',
    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
    requested_by: 'Requested by'
  },
  nb: {
    create_subject: 'Opprett fag',
    hours_in_school_year: 'Årstimetall',
    add_teacher: 'Legg til lærer',
    add_room: 'Legg til lokale',
    add_klass: 'Legg til klasse',
    more_settings: 'Flere innstillinger',
    subject_title: 'Navn på fag',
    standard_duration: 'Normal varighet (i minutter)',
    choose_class: 'Velg klasse',
    choose_color: 'Velg farge',
    choose_subject_type: 'Velg type',
    ex_subject: 'F.eks. Norsk',
    cancel: 'Angre',
    update_subject: 'Oppdater fag',
    delete_subject: 'Slett fag',
    edit_subject: 'Rediger fag',
    activity: 'Historikk',
    latest_activity: 'Aktivitet',
    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
    requested_by: 'Ønsket av'
  }
}

export default {
  components: {
    SubjectFormReductions,
    StandardDurationSetting,
    modal,
    ColorPicker,
    DSelectCalendarIds,
    DSelectUser,
    DSelectKlass,
    SubjectTypePicker,
    SubjectFormLog,
    SubjectFormDeleteSubjects
  },
  props: {
    showModal: {
      default: false
    },
    editSubject: {
      default: null
    },
    isShowSubjectsRequest: {
      type: Boolean,
      default: false
    },
    subjectsRequestsInHash: {
      type: Object,
      default: () => {
      }
    },
    isActivities: {
      type: Boolean,
      default: false
    },
    propCalendarId: {
      default: null
    },
    propTab: {
      default: null
    },
    isShowReductions: {
      default: false
    }
  },
  data () {
    return {
      preparationOptionsForNorway: [741, 711, 664, 635, 606],
      preparation: null,
      name: '',
      color: '#A0A5EF',
      calendarId: null,
      defaultDuration: 45,
      hours: 0,
      subjectType: null,
      klassCalendarIds: [],
      userCalendarIds: [],
      roomCalendarIds: [],
      formErrors: [],
      isEditSubjectAdvanced: false,
      locale: 'da',
      activeTab: 'edit', // edit, history, reductions
      subjectCode: '',
      isOpenDurationModal: false,
      isPossibleToAddKlasses: false,
      subjectsWithSameName: [],
      updatedSubject: null
    }
  },
  computed: {
    subjectRequestedBy () {
      if (!this.isShowSubjectsRequest || !this.editSubject) {
        return []
      }
      const calendarIds = this.subjectsRequestsInHash[this.editSubject.id] || []
      return calendarIds.filter(calId => this.allCalendarsInHash[calId]).map(calId => this.allCalendarsInHash[calId]['name']).join(' ,')
    },
    isArbeidstidsplanActivated () {
      return this.$store.getters.isArbeidstidsplanActivated
    },
    isReductionsActive () {
      return this.$store.getters.isReductionsActive
    },
    i18n () {
      return I18N
    },
    isAllowedToAddKlasses () {
      return this.calendarType === 'klass' || this.calendarType === 'user'
    },
    user () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    userCanManageSchool () {
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf('can_manage_school') > -1 || this.user.admin
      } else {
        return true
      }
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    editSubjectCanBeDeleted () {
      return this.editSubject && this.editSubject.can_delete
    },
    isSubjectCodeActive () {
      const schoolIsFromNorway = window.SCHOOL && window.SCHOOL.country && window.SCHOOL.country.toLowerCase() === 'no'
      const userIsJeppe = this.user && (this.user.id * 1 === 15)
      return schoolIsFromNorway || userIsJeppe
    },
    calendarType () {
      return this.calendarId ? this.allCalendarsInHash[this.calendarId].type : 'klass'
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    klassCalendarInHash () {
      return this.$store.getters.allKlassCalendarsInHash
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    showMasterCalendarName () {
      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : ''
    }
  },
  watch: {
    defaultDuration (val) {
      this.removeErrors('defaultDuration')
    }
  },
  methods: {
    selectAllOnFocus (evt) {
      setTimeout(_ => {
        evt.target.select()
      }, 0)
    },
    setSelectedUsers (users) {
      this.userCalendarIds = users.map(user => user.id)
    },
    setSelectedRooms (rooms) {
      this.roomCalendarIds = rooms.map(room => room.id)
    },
    setSelectedKlass (klasses) {
      this.klassCalendarIds = klasses.map(klass => klass.id)
    },
    addKlass (klass) {
      this.calendarId = klass.id
      this.removeErrors('calendarId')
    },
    removeKlass () {
      this.calendarId = null
    },
    setSubjectColor (val) {
      this.color = val
    },
    formValidation () {
      if (this.name.length < 1) {
        this.$set(this.formErrors, 'name', {
          da: 'Fag skal have et navn',
          en: 'Subjects must have a name',
          nb: 'Fag må ha et navn'
        })
      }
      if (this.hours < 0) {
        this.$set(this.formErrors, 'hours', {
          da: 'Skal være 0 eller højere',
          en: 'Must be zero or greater',
          nb: 'Må være 0 eller høyere'
        })
      }
      if (!this.isAValidDuration(this.defaultDuration)) {
        this.$set(this.formErrors, 'defaultDuration', {
          da: 'Må ikke være højere end 1440 minutter',
          en: 'Can not be greater than 1440 minutes',
          nb: 'Kan ikke være lengre enn 1440 minutter'
        })
      }
      if (!this.calendarId) {
        this.$set(this.formErrors, 'calendarId', {
          da: 'Skal vælges. Du kan bagefter kopiere til andre',
          en: 'Must choose a class. It can later be copied',
          nb: 'Må velges. Du kan deretter kopiere til andres'
        })
      }
    },
    removeErrors (title) {
      this.$delete(this.formErrors, title)
    },
    createSubject () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      let newSubject = {
        name: this.name,
        color: this.color,
        calendarId: this.calendarId,
        defaultDuration: this.defaultDuration,
        hours: this.hours,
        subjectType: this.subjectType,
        calendarIds: [],
        subjectCode: this.subjectCode,
        preparation: this.preparation
      }
      this.$emit('createSubject', newSubject)
    },
    updateSubject () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      let calIds = []
      this.userCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.roomCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.klassCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.updatedSubject = {
        id: this.editSubject.id,
        name: this.name,
        color: this.color,
        calendarId: this.calendarId,
        defaultDuration: this.defaultDuration,
        preparation: this.preparation,
        hours: this.hours,
        subjectType: this.subjectType,
        calendarIds: calIds,
        subjectCode: this.subjectCode
      }
      if (this.klassCalendarIds.length === 0) {
        this.$emit('updateSubject', this.updatedSubject)
      } else {
        this.checkIfAddedKlassAlreadyHasSubjectWithSameName()
      }
    },
    checkIfAddedKlassAlreadyHasSubjectWithSameName () {
      let newKlassesAddedOnSubject = []
      this.klassCalendarIds.forEach(calId => {
        if (this.editSubject.calendar_ids.indexOf(calId) < 0) {
          newKlassesAddedOnSubject.push(calId)
        }
      })
      if (newKlassesAddedOnSubject.length > 0) {
        newKlassesAddedOnSubject.forEach(calId => {
          // get all subjects for a klass
          const subjectIdsForKlass = this.subjectsInKlassHash[calId]
          const klassSubjects = subjectIdsForKlass.map(subjectId => {
            if (this.subjectsInHash[subjectId]) {
              return this.subjectsInHash[subjectId]
            }
          })
          klassSubjects.forEach(subject => {
            if (subject.name === this.name) {
              this.subjectsWithSameName.push(subject)
            }
          })
        })
        if (this.subjectsWithSameName.length === 0) {
          this.$emit('updateSubject', this.updatedSubject)
        }
      } else {
        this.$emit('updateSubject', this.updatedSubject)
      }
    },
    deleteExistingSubjects () {
      this.subjectsWithSameName.forEach(subject => {
        this.$emit('deleteSubject', subject)
      })
      this.$emit('updateSubject', this.updatedSubject)
    },
    keepExistingSubjects () {
      this.subjectsWithSameName = []
      this.$emit('updateSubject', this.updatedSubject)
    },
    closeModalSubjectsWithSameName () {
      this.subjectsWithSameName = []
    },
    deleteEditSubject () {
      this.$emit('deleteSubject', this.editSubject)
    },
    clearForm () {
      this.formErrors = []
      this.name = ''
      this.calendarIds = []
      this.hours = 0
      this.color = '#A0A5EF'
      this.setDefaultDuration()
      this.subjectCode = ''
      this.subjectsWithSameName = []
      this.updatedSubject = null
      this.preparation = ''
    },
    close () {
      this.clearForm()
      this.$emit('close')
    },
    selectSubjectType (subjectType) {
      this.subjectType = subjectType
    },
    saveUpdatedDuration () {
      this.setDefaultDuration()
      this.$refs.input_default_duration.focus()
      this.$refs.input_default_duration.select()
    },
    setDefaultDuration () {
      if (this.activeSchool && this.activeSchool.subject_default_duration) {
        this.defaultDuration = this.activeSchool.subject_default_duration
      } else {
        this.defaultDuration = 45
      }
    },
    isAValidDuration (duration) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 0 && duration < 1440
    }
  },
  beforeMount () {
    this.locale = window.USER.language ? window.USER.language : 'da'
    if (this.propTab) {
      this.activeTab = this.propTab
    }
    if (this.isActivities) {
      this.subjectType = 'activity'
    }
    if (this.editSubject) {
      this.name = this.editSubject.name
      this.color = this.editSubject.color
      this.hours = this.editSubject.hours
      this.defaultDuration = this.editSubject.default_duration
      this.subjectType = this.editSubject.subject_type
      this.calendarId = this.editSubject.calendar_id
      this.subjectCode = this.editSubject.subject_code
      if (this.editSubject.preparation) {
        this.preparation = this.editSubject.preparation
      }
      const cals = this.editSubject.calendar_ids ? this.editSubject.calendar_ids : this.editSubject.cals
      if (cals) {
        cals.forEach(calid => {
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'user') {
            this.userCalendarIds.push(calid)
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'room') {
            this.roomCalendarIds.push(calid)
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'klass' && calid !== this.calendarId) {
            this.isPossibleToAddKlasses = true
            this.klassCalendarIds.push(calid)
          }
        })
      }
    }
    if (!this.editSubject) {
      this.setDefaultDuration()
    }
  },
  mounted () {
    if (this.propCalendarId) {
      this.calendarId = this.propCalendarId
    }
    if (this.editSubject) {
      if (this.activeTab === 'edit') {
        setTimeout(_ => {
          this.$refs.inputLessonCount.focus()
        }, 500)
      }
      return
    }
    setTimeout(_ => {
      this.$refs.name.focus()
    }, 150)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.add-lesson__header {
  position: relative;
  transition: background-color 0.4s;
  padding: 30px 20px;
  color: #ffffff;
  border-radius: 4px 4px 0 0;
}

.add-lesson__header > h2 {
  color: white;
  margin-top: 0;
}

.add-lesson__form {
  position: relative;
  padding: 1rem 2rem;
  overflow-y: scroll;
  max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
}

.add-lesson__header__tabs {
  position: absolute;
  z-index: 10;
  bottom: 0;
  right: 0;
  display: flex;
}

.add-lesson__header__tabs__tab {
  margin-right: 15px;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px 4px 0 0;
}

.add-lesson__header__tabs__tab.tab--is-active {
  background-color: #f6f9fc;
  color: #3e4450;
  font-weight: bold;
}

.add-lesson__form .input-group {
  padding-bottom: 1rem;
}

.add-lesson__calendars__calendar {
  margin-left: 0.5rem;
  position: relative;
}

.add-lesson__calendars__calendar:not(:last-child):after {
  content: ',';
  position: absolute;
  bottom: 0;
  right: -5px;
}

.input-group__submit {
  display: flex;
  justify-content: space-between;
}

.input-group__flex {
  display: flex;
  flex: 1;
  width: 100%;
  gap: 1rem;
}

.input-group__flex > div {
  flex: 1;
}

.input-group__flex > .flex-2 {
  flex: 2;
}

.input-group__flex > .flex-1 {
  flex: 1;
  margin-left: 1rem;
}

.input-group input {
  background-color: #ffffff;
}

.lesson-count__edit {
  display: flex;
  align-items: center;
  max-width: 160px;
}

.lesson-count__edit input[type="number"] {
  margin: 0 0.25rem;
  text-align: center;
}

.button__delete-subject {
  color: var(--danger);
}

.expand-enter-active, .expand-leave-active {
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
}

.expand-enter, .expand-leave-to {
  transform: translateX(-0.5rem);
  opacity: 0;
}

.input-group label {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: 0.85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

.advanced-settings__link {
  cursor: pointer;
}

.advanced-settings__link:hover {
  text-decoration: underline;
}

.bttn.bttn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bttn.bttn--disabled:active {
  background: #b34e4d;
}

.input-group--flex {
  display: flex;
  align-items: center;
}

.input-group--flex input {

  width: 100%;
}

.input-group--flex > div:not(.input-group--flex__setting-icon) {
  width: 100%;
  flex: 1;
}

.input-group--flex__setting-icon {
  padding-left: 10px;
}

.text-link {
  color: var(--blue) !important;
  text-decoration: underline;
  margin-bottom: 1rem;
  cursor: pointer;
}

.subjects-requested-by {
  margin-bottom: 0.5rem;
  font-size: 11px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-transform: capitalize;
  letter-spacing: normal;
  font-style: italic;
  border: 1px solid #cec9fd;
  color: #6772e5 !important;
  background-color: #eeebff;
}

.subjects-requested-by .do-label {
  margin-bottom: 0;
  font-style: normal;
}

.input-group__submit__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

</style>



// WEBPACK FOOTER //
// SubjectForm.vue?0ce9b302